import { graphql } from "../gql";

export const unpublishAuditRuleMutationDoc = graphql(`
  mutation Unpublish($input: PublishAuditRuleInput!) {
    unpublishAuditRule(input: $input) {
      ruleId
      status
      suggestionsRequested
    }
  }
`);
